import multiguard from 'vue-router-multiguard';
import middleware from '@/router/middleware';

import LicenseTerms from '@/views/misc/LicenseTerms'
import ExpiredSubs from '@/views/misc/ExpiredSubs'
import PrivacyPolicy from '@/views/misc/PrivacyPolicy'
import StripeGateway from '@/views/misc/StripeGateway'

export default [
  {
    path: '/license-terms',
    component: LicenseTerms,
    name: 'licenseTerms',
    meta: { title: 'License Terms' },
  },
  {
    path: '/privacy-policy',
    component: PrivacyPolicy,
    name: 'privacyPolicy',
    meta: { title: 'Privacy Policy' },
  },
  {
    path: '/expire',
    component: ExpiredSubs,
    name: 'expire',
    meta: { title: 'Your subscription has expired' },
  },
  {
    path: '/stripe-gateway/:token/:plan/:period',
    component: StripeGateway,
    name: 'stripe-gateway',
    meta: { title: 'Stripe payment gateway' },
  },
];
